export default __webpack_public_path__ + "static/0254-0ea8673d769265870391165f3245e792.png";